import { render, staticRenderFns } from "./QuestionUpdate.vue?vue&type=template&id=9a46f598&scoped=true&"
import script from "./QuestionUpdate.vue?vue&type=script&lang=js&"
export * from "./QuestionUpdate.vue?vue&type=script&lang=js&"
import style0 from "./QuestionUpdate.vue?vue&type=style&index=0&id=9a46f598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a46f598",
  null
  
)

export default component.exports